import alphaValidator from "validator/es/lib/isAlpha";
import emailValidator from "validator/es/lib/isEmail";

interface Args {
  (
    value: string,
    helpers: {
      isEmpty: (string) => boolean;
    },
  ): string | null;
}

export const isAlpha: Args = (value, { isEmpty }) => {
  if (isEmpty(value)) return "Required";
  if (!alphaValidator(value)) return "Enter a valid name";
  return null;
};

export const isEmail: Args = (value, { isEmpty }) => {
  if (isEmpty(value))
    return "Please enter your Latitude ID (the email address you used to sign up to the app)";
  if (!emailValidator(value)) return "Enter a valid email address";
  return null;
};
